import React, { useEffect, useState } from "react";
import "./Order_Placed_Page.css";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import Red_Outline_Btn from "../../common_btn/red_outline_btn/Red_Outline_Btn";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import OrderPlacedSuccessfullModal from "./OrderPlacedSuccessfullModal";
import Successfull_Lottie from "../../../animation/Successfull_Lottie/Successfull_Lottie";
import { OrderResponse } from "../../../../features/order/orderSlice";

function Order_Placed_Page({ baseLink, handleManualClose, ...props }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = new URLSearchParams(window.location.search);
  const merchantOrderId = params.get("merchantOrderId");
  const id = params.get("id");
  const order_id = params.get("order_id");

  const [showModal, setShowModal] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(true);
  const [loading, setLoading] = useState(true); // loader state
  const [paymentFailed, setPaymentFailed] = useState(false); // track failure

  const handleHomeClick = () => navigate("/");
  const handleContinueShopping = () => navigate("/product-listing");
  const handleViewDetails = () => navigate(`/order-details/${id}`);
  const handleapp = () => navigate(`/openapp`);
  const handleGoToCart = () => navigate("/cart");

  useEffect(() => {
    const orderResponse = async (order_id) => {
      try {
        const data = { order_id };
        const res = await dispatch(OrderResponse(data));

        if (res.meta?.requestStatus === "fulfilled") {
          setPaymentSuccess(true);
        } else if (res.meta?.requestStatus === "rejected") {
          setPaymentFailed(true);
        }
      } catch (error) {
        setPaymentFailed(true);
      } finally {
        setLoading(false); // stop loader
      }
    };

    if (order_id) {
      orderResponse(order_id);
    } else {
      setLoading(false);
      setPaymentFailed(true);
    }
  }, [order_id, dispatch]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "20px",
          color: "#28a745",
        }}
      >
        Loading order details...
      </div>
    );
  }

  return (
    <>
      {paymentSuccess ? (
        <section className="Order_Placed_Page modal-holder">
          <div className="container">
            <div className="success_main_div">
              <div className="celebrate_lottie_holder"></div>
              <div className="success_loottie_holder">
                <Successfull_Lottie />
              </div>

              <div className="success_content_holder">
                <div className="text_holder">
                  <p className="heading">Order Placed Successfully</p>
                  <p className="sub_text">
                    Order placed successfully your product will be <br />{" "}
                    delivered soon.
                  </p>
                </div>
              </div>

              <div className="text-center btn_holder">
                <div className="home_btn">
                  <Red_Outline_Btn
                    btn_name="Go to Home"
                    onClick={handleHomeClick}
                  />
                </div>
                <div className="continue_btn">
                  <Green_Btn
                    btn_name="Continue Shopping"
                    onClick={handleContinueShopping}
                  />
                </div>
                {/* <div className="home_btn">
                  <a href="https://chefcuts.in/openapp" target="_blank" class="btn"><Green_Btn btn_name="Go to app"  /></a>                 
                </div> */}
              </div>

              <div className="track_order_div">
                <div className="left_side_div">
                  <div className="text_holder">
                    <div className="title">
                      <p>Track Your Order</p>
                    </div>
                    <div className="footer_text">
                      <p>Rider will be assigned soon</p>
                    </div>
                  </div>
                </div>

                <div className="right_side">
                  <div className="text-center btn_holder">
                    <Green_Btn
                      btn_name="View Details"
                      onClick={handleViewDetails}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <OrderPlacedSuccessfullModal
            show={showModal}
            onHide={() => setShowModal(false)}
          />
        </section>
      ) : paymentFailed ? (
        <section className="Order_Failed_Page modal-holder">
          <div className="container">
            <div
              className="failed_main_div"
              style={{ textAlign: "center", padding: "50px 0" }}
            >
              <div className="failed_lottie_holder"></div>
              <h2 style={{ color: "#dc3545", margin: "20px 0" }}>
                Order Failed
              </h2>
              <p style={{ color: "#555", fontSize: "16px" }}>
                Unfortunately, your order could not be processed.
                <br />
                Please try again or check your cart.
              </p>

              <div
                className="btn_holder"
                style={{
                  marginTop: "30px",
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                }}
              >
                <Red_Outline_Btn
                  btn_name="Go to Home"
                  onClick={handleHomeClick}
                />
                <Green_Btn btn_name="Go to Cart" onClick={handleGoToCart} />
              </div>
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}

export default Order_Placed_Page;
